import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/** admin_settings key holding the site-wide PODGO logo URL. */
export const BRAND_LOGO_KEY = "branding_logo_url";

/**
 * Site-wide PODGO logo configured in Theme Options → Branding.
 * Returns an empty string when no logo is set, so call sites fall back to the
 * built-in wordmark. Cached app-wide: every header/footer shares one fetch.
 */
export function useBrandLogo() {
  const query = useQuery<string>({
    queryKey: ["brand-logo"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("admin_settings")
        .select("value")
        .eq("key", BRAND_LOGO_KEY)
        .maybeSingle();
      if (error) throw error;
      return data?.value ?? "";
    },
    staleTime: 5 * 60 * 1000,
    // NOT `initialData`: that seeds the cache as already-fetched *fresh* data,
    // so within `staleTime` a cold mount would never fetch and every logo spot
    // would fall back to the built-in wordmark, looking like the upload
    // reverted. `placeholderData` keeps the empty-string contract for callers
    // while still issuing the request.
    placeholderData: "",
  });

  return { ...query, data: query.data ?? "" };
}

